import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import reportWebVitals from "./reportWebVitals";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "_metronic/_assets/plugins/flaticon/flaticon.css";
import "_metronic/_assets/plugins/flaticon2/flaticon.css";
import "_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "bootstrap/scss/bootstrap.scss";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "semantic-ui-css/semantic.min.css";
import "socicon/css/socicon.css";
import "./index.scss";

import ReduxToastr from "react-redux-toastr";
import Application from "./application";
import { applyFontConfig } from "./theme/fontConfig";

applyFontConfig();


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ReduxToastr
        timeOut={4000}
        newestOnTop={false}
        preventDuplicates
        position="top-right"
        getState={(state) => state.toastr} // This is the default
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick
      />
      <Application />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
